'use client';

import cn from 'classnames';
import { usePathname } from 'next/navigation';
import { useState, useEffect } from 'react';

import MarketingTopbar from '@/components/MarketingTopbar';
import MenuWrapper from '@/components/MenuWrapper';
import ProgressBar from '@/components/ProgressBar';
import SearchBarMobileWrapper from '@/components/SearchBarMobileWrapper';
import SocialHeader from '@/components/SocialHeader';
import TopbarWrapper from '@/components/TopbarWrapper';

import styles from './styles.module.scss';
import { Props } from './types';

const HeaderWrapper = ({
  menuData,
  contactData,
  marketingTopbarData,
}: Props) => {
  const [isOnlyLogo, setIsOnlyLogo] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    if (pathname?.includes('/logowanie')) {
      setIsOnlyLogo(true);
    } else {
      setIsOnlyLogo(false);
    }
  }, [pathname]);

  return (
    <>
      {!isOnlyLogo && marketingTopbarData && (
        <>
          <MarketingTopbar marketingTopbarData={marketingTopbarData} />
          <SocialHeader />
        </>
      )}

      <nav
        className={cn(styles.nav, {
          [styles.onlyLogoFixed]: isOnlyLogo,
        })}
      >
        <ProgressBar />
        <TopbarWrapper onlyLogo={isOnlyLogo} />
        {!isOnlyLogo && menuData && (
          <div className={styles.navigation}>
            <MenuWrapper data={menuData} contactData={contactData.data} />
            <div className={styles.searchMobile}>
              <SearchBarMobileWrapper />
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default HeaderWrapper;
